import { useCallback, useEffect, useState } from 'react';

export function useRequisicao(buscar) {
  const [dados, setDados] = useState(null);
  const [carregando, setCarregando] = useState(true);
  const [erro, setErro] = useState(false);

  const recarregar = useCallback(async () => {
    setCarregando(true);
    setErro(false);
    try {
      setDados(await buscar());
    } catch {
      setErro(true);
    } finally {
      setCarregando(false);
    }
  }, [buscar]);

  useEffect(() => {
    let ativo = true;
    setCarregando(true);
    setErro(false);
    buscar()
      .then((r) => ativo && setDados(r))
      .catch(() => ativo && setErro(true))
      .finally(() => ativo && setCarregando(false));
    return () => {
      ativo = false;
    };
  }, [buscar]);

  return { dados, carregando, erro, recarregar };
}
